module.exports = __webpack_public_path__ + "img/financeIndicators.a791044a.png";